import { MainLayoutV2 } from "../../components/main-layout-v2/main-layout-v2";
import { MainNavigation } from "../../components/main-navigation/main-navigation";
import { Sidebar } from "../../components/sidebar/sidebar";
import { memo, useState } from "react";
// import { memo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectSettings } from "../../store/slices/settings";
import { selectIsSystemAdmin } from "../../store/slices/user";
import { useAccess } from "../../common/utils/usePermissions";
import { visibleItems } from "../../common/permissions/screens";

export const Administration = memo(() => {
  const { pathname } = useLocation();
  const settings = useSelector(selectSettings);
  const access = useAccess();
  const isSystemAdmin = useSelector(selectIsSystemAdmin);
  const sitesEnabled = settings?.find((s) => s.key === "sitesEnable")?.value === true;
  // Sites belong to the project, so they sit with its settings (LF360-2037).
  const sitesNavigation = sitesEnabled ? [{ key: "/administration/sites", label: "Sites" }] : [];

  // LF360-2024: one menu, each screen shown to whoever may open it
  // (common/permissions/screens.js).
  const fullNavigation = [
    {
      label: "Organization settings",
      type: "group",
      children: [
        {
          key: "/administration/system-users",
          label: "Organization users",
          default:
            pathname === "/administration" ||
            pathname === "/administration/system-users",
        },
        {
          key: "/administration/authentication",
          label: "Authentication",
        },
        // LF360-2043: Organization and System admins only, like the whole group.
        {
          key: "/administration/roles",
          label: "Roles and permissions",
        },
      ],
    },
    {
      label: "Project settings",
      type: "group",
      children: [
        { key: "/administration/project-settings", label: "General settings" },
        { key: "/administration/profiles", label: "Subject profile" },
        { key: "/administration/enrollment", label: "Subject Invitation" },
        { key: "/administration/cohorts", label: "Cohorts" },
        { key: "/administration/functionality", label: "Functionality" },
        ...sitesNavigation,
        { key: "/administration/notifications", label: "Notifications" },
        { key: "/administration/lifepoints", label: "LifePoints" },
        { key: "/administration/mobile-home-page", label: "Mobile home page" },
        { key: "/administration/lifebot", label: "LifeBot" },
        { key: "/administration/legal-documents", label: "Legal documents" },
        { key: "/administration/project-ai-connectors", label: "AI connectors" },
        {
          key: "/administration/project-users",
          label: "Project users",
          default:
            !access.isOrgAdmin &&
            (pathname === "/administration" ||
              pathname === "/administration/project-users"),
        },
      ],
    },
    // System-admin-only diagnostic hub. Hidden from regular admins because
    // the linked tools require systemAdmin too — showing the entry to other
    // roles would just bounce them on click.
    // ...(isSystemAdmin
    //   ? [
    //       {
    //         label: "Diagnostics",
    //         type: "group",
    //         children: [
    //           { key: "/administration/tools", label: "Admin tools" },
    //         ],
    //       },
    //     ]
    //   : []),
  ];

  // LF360-2100: AI connectors are the System admin's switch, not a project
  // permission, so they are not in SCREENS; the route sits behind
  // RequireSystemAdmin and the item is added for System admins only.
  const navigation = visibleItems(access, fullNavigation).map((group) => (
    isSystemAdmin && group.label === "Organization settings"
      ? { ...group, children: [...group.children, { key: "/administration/ai-connectors", label: "AI connectors (MCP)" }] }
      : group
  ));

  const [sidebarProps, setSidebarProps] = useState({ title: "Administration" });
  return (
    <MainLayoutV2>
      <MainNavigation />
      <Sidebar items={navigation} {...sidebarProps} />
      <Outlet context={{ setSidebarProps }} />
    </MainLayoutV2>
  );
});
